import { render } from "./TranslationListView.vue?vue&type=template&id=525ffef0&scoped=true&ts=true"
import script from "./TranslationListView.vue?vue&type=script&lang=ts"
export * from "./TranslationListView.vue?vue&type=script&lang=ts"

import "./TranslationListView.vue?vue&type=style&index=0&id=525ffef0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525ffef0"]])

export default __exports__